import { render, staticRenderFns } from "./grab.vue?vue&type=template&id=2593c871&"
import script from "./grab.vue?vue&type=script&lang=js&"
export * from "./grab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports